var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarpolish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(-846.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(560 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_14216224191637204295",
    "data-name": 14216224191637205000,
    transform: "translate(893.29 2698.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M76.55,29.6a4.386,4.386,0,0,0-3.6-.6,3.934,3.934,0,0,0-2.7,2.4L67.4,38.15l.9-14.1a3.959,3.959,0,0,0-1.05-2.85A4.1,4.1,0,0,0,64.4,20a3.852,3.852,0,0,0-3.75,3.15l-2.4,11.7-1.5-11.4A4.018,4.018,0,0,0,52.85,20a4.081,4.081,0,0,0-4.05,3.75l-.75,12-2.7-8.25a4.535,4.535,0,0,0-2.55-2.7,4.211,4.211,0,0,0-3.75.45,4.14,4.14,0,0,0-1.65,4.5L44.15,55.1a1.124,1.124,0,0,1-.15.75.929.929,0,0,1-.6.3.8.8,0,0,1-.6-.45l-4.5-7.05a3.705,3.705,0,0,0-2.85-1.8A4.052,4.052,0,0,0,32.3,47.9a3.529,3.529,0,0,0-.9,3.75l4.2,13.5c.15.45.3.75.45,1.2H11.15a6.05,6.05,0,0,1-6.15-6V16.85c.45,0,.9.15,1.5.15h57A7.712,7.712,0,0,0,68,15.5v3h3V8h-.15A7.545,7.545,0,0,0,63.5,2H6.5A4.42,4.42,0,0,0,2,6.5a4.188,4.188,0,0,0,1.2,3,4.188,4.188,0,0,0-1.2,3V60.35a9.286,9.286,0,0,0,9.15,9.15h26.1a31.113,31.113,0,0,0,2.85,4.8l.6.75C43.85,79.25,45.95,86,45.95,92h3c0-6.75-2.25-13.95-5.85-18.75l-.6-.75a25.668,25.668,0,0,1-4.05-8.1l-4.2-13.5a.66.66,0,0,1,.15-.75c.3-.3.45-.3.6-.15a1.137,1.137,0,0,1,.6.3l4.5,7.05a3.705,3.705,0,0,0,2.85,1.8,3.811,3.811,0,0,0,4.2-4.65L40.4,29a1,1,0,0,1,.45-1.2,1.232,1.232,0,0,1,1.05-.15,1.808,1.808,0,0,1,.75.75L47.6,44.6a1.382,1.382,0,0,0,1.65,1.05c.75-.15,1.35-.6,1.35-1.35l1.35-20.25a1,1,0,0,1,1.05-.9,1.1,1.1,0,0,1,1.05.9l2.7,20.4a1.6,1.6,0,0,0,1.5,1.35,1.461,1.461,0,0,0,1.5-1.2L63.5,23.75a.951.951,0,0,1,.9-.75c.3,0,.6.15.6.3a.779.779,0,0,1,.3.6L63.95,46.85a1.461,1.461,0,0,0,1.2,1.5,1.294,1.294,0,0,0,1.65-.9L72.95,32.6c.15-.45.6-.6.75-.75a1.442,1.442,0,0,1,1.05.15,1.21,1.21,0,0,1,.45,1.35L69.8,52.4V65.15A27.147,27.147,0,0,1,67.7,75.5a30.023,30.023,0,0,0-2.4,11.55V92h3V87.2a27.147,27.147,0,0,1,2.1-10.35A30.023,30.023,0,0,0,72.8,65.3V53.15l5.4-18.9A3.929,3.929,0,0,0,76.55,29.6ZM6.5,8A1.417,1.417,0,0,1,5,6.5,1.417,1.417,0,0,1,6.5,5h57A4.42,4.42,0,0,1,68,9.5,4.42,4.42,0,0,1,63.5,14H6.5A1.417,1.417,0,0,1,5,12.5,1.417,1.417,0,0,1,6.5,11H59V8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M61.25,13A5.315,5.315,0,0,0,56,18.25v1.5A2.307,2.307,0,0,1,53.75,22H50v3h3.75A5.315,5.315,0,0,0,59,19.75v-1.5A2.307,2.307,0,0,1,61.25,16a5.315,5.315,0,0,0,5.25-5.25V9.25A5.315,5.315,0,0,0,61.25,4H50V7H61.25A2.307,2.307,0,0,1,63.5,9.25v1.5A2.307,2.307,0,0,1,61.25,13Z",
    transform: "translate(24 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 6,
    height: 3,
    transform: "translate(86 35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 6,
    height: 3,
    transform: "translate(80 44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 3,
    height: 3,
    transform: "translate(89 44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 10,
    height: 3,
    transform: "translate(76 55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 3,
    height: 3,
    transform: "translate(89 55)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpolish);
export default __webpack_public_path__ + "static/media/carpolish.ce36ed1b6085ffbd7b0abaed33b1beae.svg";
export { ForwardRef as ReactComponent };